const code1 = `<el-empty description="description"></el-empty>`;

const code2 = `<el-empty image="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"></el-empty>`;

const code3 = `<el-empty :image-size="200"></el-empty>`;

const code4 = `<el-empty>
  <el-button type="primary">Button</el-button>
</el-empty>`;

export { code1, code2, code3, code4 };
